import { Flex } from '@opendoor/bricks/core';
import { BREAKPOINTS_DICT } from '@opendoor/bricks/theme/eero/foundations/breakpoints';

interface ParnLeadDetailsLayoutProps {
  isMobile: boolean;
  children?: React.ReactNode;
}

// storybook-check-ignore
export const ParnLeadDetailsLayout: React.FC<ParnLeadDetailsLayoutProps> = ({
  children,
  isMobile,
}) => (
  <Flex
    data-testid="parn-lead-details-layout-content"
    flexDirection="column"
    mx="auto"
    gridGap="4"
    width="100%"
    maxWidth={BREAKPOINTS_DICT.LG}
    padding={isMobile ? '0 8px 8px 8px' : '0 50px 0px 50px'}
  >
    {children}
  </Flex>
);
